import BaseAPI from './base'
/**
 * API xử lý học sinh (tổng quan)
 */
class DashboardAPI extends BaseAPI {}

export default new DashboardAPI('v1/dashboard', 'Dashboard')
